import notifications from 'notifications';
import ExtractedQuerySequence from 'search/blast/ExtractedQuerySequence';
import * as TaskRunner from 'util/TaskRunner';

interface ExtractedNucleotides {
  name: string;
  bases: string;
}

interface ExtractedAminoAcids {
  name: string;
  aminoAcids: string;
}

export async function extractAaSequences(s3Locations: Array<string>): Promise<Array<ExtractedQuerySequence>> {
  const result = await TaskRunner.postJSONPromise({
    url: '/1/api/aa-sequences/extract-from-files',
    data: {fileLocations: s3Locations},
  });
  if (result.errors && result.errors.length) {
    notifications.error(result.errors.join('\n'));
  }
  if (result.warnings && result.warnings.length) {
    notifications.warn(result.warnings.join('\n'));
  }
  return result.extractedProteins.map((es: ExtractedAminoAcids) => ({
    name: es.name,
    sequence: es.aminoAcids,
  }));
}

export async function extractSequences(s3Locations: Array<string>): Promise<Array<ExtractedQuerySequence>> {
  const result = await TaskRunner.postJSONPromise({
    url: '/1/api/sequences/extract-from-files',
    data: {fileLocations: s3Locations},
  });
  if (result.errors && result.errors.length) {
    notifications.error(result.errors.join('\n'));
  }
  if (result.warnings && result.warnings.length) {
    notifications.warn(result.warnings.join('\n'));
  }
  return result.extractedSequences.map((es: ExtractedNucleotides) => ({
    name: es.name,
    sequence: es.bases,
  }));
}
